__turbopack_context__.v({
  "copyWrapper": "O8lX0G_copyWrapper",
  "icon": "O8lX0G_icon",
});
